const podcasts_fr = require('./podcasts.json')
export default podcasts_fr